// Wraps the real `@juggle/resize-observer` polyfill (which rsuite imports
// directly for its picker/overlay positioning — see
// node_modules/rsuite/esm/utils/useElementResize.js) so every callback runs
// as a microtask instead of synchronously inside the resize-observation
// cycle.
//
// "ResizeObserver loop completed with undelivered notifications" fires when a
// callback itself triggers another resize within the same cycle (exactly what
// rsuite's DateRangePicker does when it measures its calendar panel to decide
// how to position the popup). Deferring the callback means it never runs
// inside that cycle, so the loop-limit condition this error reports can't
// occur — this isn't error suppression, it prevents the condition itself.
//
// queueMicrotask (not requestAnimationFrame) deliberately: a microtask runs
// before the browser's next paint, in the same frame, so the popup's
// unpositioned initial state is never actually painted to the screen — rAF
// waits for the *next* paint opportunity, so the browser can and does paint
// the wrong position first, producing a visible one-frame flash/blink.
//
// Wired up via craco.config.js aliasing the exact `@juggle/resize-observer`
// specifier to this file, so every importer (rsuite included) gets the
// wrapped version without needing to patch node_modules directly.
import { ResizeObserver as RealResizeObserver } from "@juggle/resize-observer/lib/exports/resize-observer.js";

export class ResizeObserver extends RealResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      queueMicrotask(() => {
        callback(entries, observer);
      });
    });
  }
}

export default ResizeObserver;
